import { render, staticRenderFns } from "./services2.vue?vue&type=template&id=9124dfa4"
import script from "./services2.vue?vue&type=script&lang=js"
export * from "./services2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports